var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { PageLoading, MyLessons, DETAILS_QUERY_PARAMS, MyLessonDetails } from '../organisms';
import { UserChallengeStatus } from '@lean-body/src/interfaces';
import { useQuery } from '@lean-body/src/util';
import { MediaBreakPointUp } from '../styles';
const LESSON_HISTORY_FIRST_PAGE = 0;
const FAVORITE_LESSON_FIRST_PAGE = 1;
export const DISPLAY_LESSON_PER_PAGE = 20;
export const MainMyLesson = ({ apiClient, tracker, config }) => {
    const query = useQuery();
    const selectedDetails = query.get(DETAILS_QUERY_PARAMS) || '';
    const isSelectDetails = selectedDetails !== '';
    const [subscribedLiveLesson, setSubscribedLiveLesson] = React.useState([]);
    const [challengingPlaylist, setChallengingPlaylist] = React.useState([]);
    const [lessonHistories, setLessonHistories] = React.useState([]);
    const [lessons, setLessons] = React.useState([]);
    const [programs, setPrograms] = React.useState([]);
    const [playlists, setPlaylists] = React.useState([]);
    const [originalPlaylists, setOriginalPlaylists] = React.useState([null]);
    const [lessonHistoryPage, setLessonHistoryPage] = React.useState(LESSON_HISTORY_FIRST_PAGE);
    const [favoriteLessonPage, setFavoriteLessonPage] = React.useState(FAVORITE_LESSON_FIRST_PAGE);
    const [isLoadingSubscribedLiveLesson, setIsLoadingSubscribedLiveLesson] = React.useState(true);
    const [isLoadingChallengingPlaylist, setIsLoadingChallengingPlaylist] = React.useState(true);
    const [isLoadingLessonHistories, setIsLoadingLessonHistories] = React.useState(true);
    const [isLoadingLessons, setIsLoadingLessons] = React.useState(true);
    const [isLoadingProgramsAndPlaylists, setIsLoadingProgramsAndPlaylists] = React.useState(true);
    const [isLoadingOriginalPlaylists, setIsLoadingOriginalPlaylists] = React.useState(true);
    const isLoading = () => {
        if (isSelectDetails) {
            switch (selectedDetails) {
                case MyLessonDetails.subscribedLiveLesson:
                    return isLoadingSubscribedLiveLesson;
                case MyLessonDetails.challengingPlaylist:
                    return isLoadingChallengingPlaylist;
                case MyLessonDetails.lessonHistory:
                    return isLoadingLessonHistories;
                case MyLessonDetails.lesson:
                    return isLoadingLessons;
                case MyLessonDetails.program:
                case MyLessonDetails.playlist:
                    return isLoadingProgramsAndPlaylists;
                case MyLessonDetails.originalPlaylist:
                    return isLoadingChallengingPlaylist;
            }
        }
        else {
            return (isLoadingSubscribedLiveLesson ||
                isLoadingChallengingPlaylist ||
                isLoadingLessonHistories ||
                isLoadingLessons ||
                isLoadingProgramsAndPlaylists ||
                isLoadingOriginalPlaylists);
        }
    };
    React.useEffect(() => {
        // 参加予定のLIVEレッスン
        if (!isSelectDetails || selectedDetails === MyLessonDetails.subscribedLiveLesson) {
            setIsLoadingSubscribedLiveLesson(true);
            if (subscribedLiveLesson.length > 0) {
                setIsLoadingSubscribedLiveLesson(false);
            }
            else {
                apiClient
                    .fetchSubscribedLiveLesson()
                    .then((fetchSubscribedLiveLesson) => {
                    setSubscribedLiveLesson(fetchSubscribedLiveLesson);
                })
                    .finally(() => {
                    setIsLoadingSubscribedLiveLesson(false);
                });
            }
        }
        // チャレンジ中のプレイリスト
        if (!isSelectDetails || selectedDetails === MyLessonDetails.challengingPlaylist) {
            setIsLoadingChallengingPlaylist(true);
            if (challengingPlaylist.length > 0) {
                setIsLoadingChallengingPlaylist(false);
            }
            else {
                apiClient
                    .fetchUserChallengesByChallengeStatus(UserChallengeStatus.ChallengeInProgress)
                    .then((fetchChallengingPlaylist) => {
                    setChallengingPlaylist(fetchChallengingPlaylist);
                })
                    .finally(() => {
                    setIsLoadingChallengingPlaylist(false);
                });
            }
        }
        // 視聴履歴
        if (!isSelectDetails || selectedDetails === MyLessonDetails.lessonHistory) {
            setIsLoadingLessonHistories(true);
            if (lessonHistories.length > 0) {
                setIsLoadingLessonHistories(false);
            }
            else {
                apiClient
                    .fetchLessonSession(LESSON_HISTORY_FIRST_PAGE)
                    .then((histories) => {
                    setLessonHistories(histories);
                })
                    .finally(() => {
                    setIsLoadingLessonHistories(false);
                });
            }
        }
        // お気に入りのレッスン
        if (!isSelectDetails || selectedDetails === MyLessonDetails.lesson) {
            setIsLoadingLessons(true);
            if (lessons.length > 0) {
                setIsLoadingLessons(false);
            }
            else {
                apiClient
                    .fetchFavoriteLessons(FAVORITE_LESSON_FIRST_PAGE)
                    .then((fetchLessons) => {
                    setLessons(fetchLessons);
                })
                    .finally(() => {
                    setIsLoadingLessons(false);
                });
            }
        }
        // お気に入りのシリーズ、お気に入りのプレイリスト
        if (!isSelectDetails ||
            selectedDetails === MyLessonDetails.program ||
            selectedDetails === MyLessonDetails.playlist) {
            setIsLoadingProgramsAndPlaylists(true);
            if (programs.length > 0 && playlists.length > 0) {
                setIsLoadingProgramsAndPlaylists(false);
            }
            else {
                apiClient
                    .fetchFavoritePrograms()
                    .then((fetchedPrograms) => {
                    setPrograms(fetchedPrograms.filter((v) => !v.isPlaylist));
                    setPlaylists(fetchedPrograms.filter((v) => v.isPlaylist));
                })
                    .finally(() => {
                    setIsLoadingProgramsAndPlaylists(false);
                });
            }
        }
        // オリジナルプレイリスト
        if (!isSelectDetails || selectedDetails === MyLessonDetails.originalPlaylist) {
            setIsLoadingOriginalPlaylists(true);
            // 作成用のカードをデフォルトで追加するので未取得の場合でも1になる
            if (subscribedLiveLesson.length > 1) {
                setIsLoadingOriginalPlaylists(false);
            }
            else {
                apiClient
                    .getOriginalPlaylists()
                    .then((fetchOriginalPlaylists) => {
                    setOriginalPlaylists(fetchOriginalPlaylists.concat(null));
                })
                    .finally(() => {
                    setIsLoadingOriginalPlaylists(false);
                });
            }
        }
    }, [selectedDetails]);
    const onClickLessonHistoryNext = () => __awaiter(void 0, void 0, void 0, function* () {
        const nextLessonHistoryPage = lessonHistoryPage + 1;
        const histories = yield apiClient.fetchLessonSession(nextLessonHistoryPage);
        setLessonHistories(lessonHistories.concat(histories));
        setLessonHistoryPage(nextLessonHistoryPage);
    });
    const onClickLessonNext = () => __awaiter(void 0, void 0, void 0, function* () {
        const nextFavoriteLessonPage = favoriteLessonPage + 1;
        const fetchLessons = yield apiClient.fetchFavoriteLessons(nextFavoriteLessonPage);
        setLessons(lessons.concat(fetchLessons));
        setFavoriteLessonPage(nextFavoriteLessonPage);
    });
    if (isLoading()) {
        return React.createElement(PageLoading, null);
    }
    return (React.createElement("div", { className: css(styles.container, isSelectDetails && styles.detail) },
        React.createElement(MyLessons, { config: config, details: selectedDetails, subscribedLiveLessons: subscribedLiveLesson, challengingPlaylists: challengingPlaylist, histories: lessonHistories, lessons: lessons, seriesPrograms: programs, playlists: playlists, originalPlaylists: originalPlaylists, onClickLessonHistoryNext: onClickLessonHistoryNext, onClickLessonNext: onClickLessonNext, apiClient: apiClient, tracker: tracker })));
};
const styles = StyleSheet.create({
    container: {
        padding: '17px 0 28px 20px',
        [MediaBreakPointUp.MD]: {
            padding: '30px 48px 50px',
        },
        [MediaBreakPointUp.XL]: {
            padding: '50px 78px 80px',
        },
    },
    detail: {
        paddingRight: 20,
        [MediaBreakPointUp.MD]: {
            padding: '0px 48px 50px',
        },
        [MediaBreakPointUp.XL]: {
            padding: '0px 12px 80px',
        },
    },
});
